import { Currency, formatBalance } from '@ui/src';
import { BeneficiaryContract } from '../types';
import getStatusName from './get-status-name';

const formatBeneficiaryContractsList = (
  list: BeneficiaryContract[],
  baseCurrency?: Currency,
  currencies?: Currency[],
): BeneficiaryContract[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {
      sum: (
        <div>
          {result?.sum
            ? `${formatBalance(
                result?.sum,
                currencies?.find(
                  (currency) => currency.id === result?.currencyId,
                ) || baseCurrency,
              )} ${
                result?.currencyId
                  ? currencies?.find(
                      (currency) => currency.id === result?.currencyId,
                    )?.name
                  : ''
              }`
            : '-'}
        </div>
      ),
      description: <div>{result?.description || '-'}</div>,
      status: <div>{getStatusName(result?.status)}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatBeneficiaryContractsList;
